import { History } from 'history'
import { Box, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { formState$ } from "src/store/vendas/projetos/store";
import theme from "src/theme/light";
import { DEFAULT_PROJETO } from "../constants";
import { PermissionUtil } from 'src/framework/commons/PermissionUtil';
import { confirmationDialog } from 'src/framework/store/ConfirmationDialogStore';

interface ProjetoSalvoComSucessoDialogOptions {
  onConfirmation?: () => void
  onNegation?: () => void
  onClose?: () => void
  onlyConfirm?: boolean
  tipoProjeto?: string
}

export function projetoSalvoComSucessoDialog(codigoVenda: string, history: History<any>, options: ProjetoSalvoComSucessoDialogOptions = {}){
  const userPermissions = PermissionUtil.getPermissions()

  const temPermissaoListagem = PermissionUtil.can(PermissionUtil.PROJETOS_LISTAGEM, userPermissions)

  confirmationDialog.setup({
    onlyConfirm: options?.onlyConfirm || !temPermissaoListagem,
    content: `Seu projeto ${codigoVenda} foi salvo com sucesso.`,
    size: '440px',
    title: (
      <Box alignItems={'center'} display='flex' justifyContent='space-between' width={"100%"}>
        <Box>
          <Typography variant="h5" color="textPrimary">
            Sucesso!
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Projeto salvo com sucesso.
          </Typography>
        </Box>
      </Box>
    ),
    headerIcon: <CheckCircle htmlColor={theme.palette.primary.dark}/>, 
    yesText: 'Novo Projeto',
    noText: 'Ir para Listagem',
    propagateWhenConfirm: false,
    onNegation: () => {
      if (options.onNegation) options.onNegation()
      confirmationDialog.close();
      formState$.next(DEFAULT_PROJETO)
      history.replace('/projetos/menu-projetos', { done: true })
    },
    onClose: () => {
      if (options.onClose) options.onClose()
      confirmationDialog.close();
      formState$.next(DEFAULT_PROJETO)
      history.replace('/projetos/menu-projetos', { done: true })
    },
    onConfirmation: () => {
      if (options.onConfirmation) options.onConfirmation()
      confirmationDialog.close();
      formState$.next(DEFAULT_PROJETO)
      const useTipoProjeto = options.tipoProjeto && ['dimensionado', 'personalizado', 'vertical', 'dimensionado_offgrid', 'dimensionado_hibrido', 'personalizado_offgrid', 'personalizado_hibrido'].includes(options.tipoProjeto);
      const urlRedirect = useTipoProjeto ? `/projetos?tipo=${options.tipoProjeto}` : `/projetos`
      history.replace(urlRedirect, { done: true })
    }
  })
  confirmationDialog.open()
}